import { autobind } from "core-decorators";
import { uiPermission } from "../routes/Auth/Module";

@autobind
/**
 *
 */
export default class Authorize {
  /**
   *
   * @param {Object} store
   */
  constructor(store) {
    this._store = store;
  }

  isAdmin = () => {
    let roles = this._store.getState().Auth.currentUser.roles || [];
    const isAdminItem = (role) => {
      return role && role.name === "admin";
    };
    if (roles.find(isAdminItem)) {
      return true;
    }
    return false;
  };

  /**
   *
   * @param {String} permission
   * @return {Boolean}
   * @private
   */
  _has(permission) {
    if (this._store.getState().Auth.currentPermissions) {
      if (permission === "isAdmin" && this.isAdmin()) {
        return true;
      } else if (permission === "isNotAdmin" && !this.isAdmin()) {
        return true;
      }
      if (this.isAdmin()) return true;
      return this._store
        .getState()
        .Auth.currentPermissions.contains(permission);
    }
    return false;
  }

  /**
   *
   * @return {Boolean}
   */
  can(...permissions) {
    // if(permissions[0] !== 'isNotAdmin')
    // return true;
    if (this.isAdmin()) {
      return true;
    }
    if (permissions.isEmpty()) {
      return false;
    }

    for (const permission of permissions) {
      if (!this._has(permission)) {
        return false;
      }
    }

    return true;
  }

  /**
   *
   * @return {Boolean}
   */
  ability(...permissions) {
    // return true;
    if (this._store.getState().Auth.currentPermissions) {
      if (this.isAdmin()) return true;
    }
    if (app._.isEmpty(permissions)) {
      return false;
    }

    if (permissions[0] === "uiPermission") {
      let uiPermissions = this._store.getState().Auth.uiPermissions;
      if (app._.isEmpty(uiPermissions)) {
        return false;
      }
      if (!(permissions[1] && uiPermissions.indexOf(permissions[1]) > -1))
        return false;
    }

    for (const permission of permissions) {
      if (this._has(permission)) {
        return true;
      }
    }

    return false;
  }

  haveMenu(permissions) {

    // if (this._store.getState().Auth.currentPermissions) {
    if (this.isAdmin()) {
      if (permissions && permissions[1] && permissions[1] === "isNotAdmin") {
        return false;
      } else if (permissions && permissions[1] && permissions[1] === "isAdmin") {
        return true;
      } else if (permissions && permissions[1]) {
        if (app.haveUiPermission([permissions[permissions.length - 1]])) {
          return true;
        }
        return false;
      }
      return true;
    }
    
    // Check for isAdmin permission when user is not admin
    if (permissions && permissions[1] && permissions[1] === "isAdmin") {
      return false;
    }
    
    if (app._.isEmpty(permissions)) {
      return true;
    }

    if (permissions) {
      // if (this._has(permissions)) {
      var BreakException = "find";
      var notUiPermission = "dont have ui permission";
      try {
        this._store.getState().Auth.currentPermissions.forEach(function (str) {
          if (str.startsWith(permissions[0])) {
            if (permissions[1]) {
              if (app.haveUiPermission([permissions[permissions.length - 1]])) {
                throw BreakException;
              } else {
                throw notUiPermission;
              }
            } else {
              throw BreakException;
            }
          }
        });
      } catch (e) {
        if (e === BreakException) {
          return true;
        }
        if (e === notUiPermission) {
          return false;
        }
      }
    }
    // return false;
    // }
    return false;
  }

  /**
   *
   * @return {Boolean}
   */
  haveUiPermission(permissions) {
    if (app._.isEmpty(permissions)) {
      return false;
    }

    if (permissions[0]) {
      let uiPermissions = this._store.getState().Auth.uiPermissions;
      if (app._.isEmpty(uiPermissions)) {
        return false;
      }

      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i] && uiPermissions.indexOf(permissions[i]) > -1)
          return true;
      }
    }
    return false;
  }
}
